<template>
  <div v-if="typeof user !== 'undefined'">
    <div class="has-text-centered">
      <strong>Account Number:</strong>
      {{ user.account_number ? user.account_number : 'N/A' }}
      <br />
      <br />
    </div>
    <div class="columns">
      <div class="column">
        <h2 class="subtitle">Billing</h2>
        <span v-if="editingUser">
                    <button class="button" @click="editingUser = false">Stop Editing (lose changes)</button>
                    <br />
                    <br />
                </span>
        <user-form :user="user" @saved="editingUser = false" v-if="editingUser"></user-form>
        <div class="columns" v-if="!editingUser">
          <div class="column is-5">
            {{ user.first_name }} {{ user.last_name }} <br />
            {{ user.phone | phone }} <br />
            {{ user.email }}
          </div>
          <div class="column">
            {{ user.line1 }} {{ user.line2 }} {{ user.line3 }} <br />
            {{ user.city }}, {{ user.state }} {{ user.zip }} {{ user.country }} <br />
            Timezone: {{ user.timezone }}
          </div>
        </div>
        <div v-if="isSuperUser">
          <button class="button is-small" @click="editingUser = true" v-if="!editingUser">Edit User</button>
        </div>
        <br />
        <br />
        <br />
        <h2 class="subtitle">Recipients</h2>
        <div v-for="recipient in recipients">
                    <span v-if="editingRecipient === recipient.id">
                        <button class="button" @click="editingRecipient = false">Cancel Editing (lose changes)</button>
                        <br />
                        <br />
                    </span>
          <user-recipient-form v-if="editingRecipient === recipient.id"
                               :recipient="recipient"
                               @saved="editingRecipient = false"></user-recipient-form>
          <div class="columns" v-if="editingRecipient !== recipient.id">
            <div class="column is-5">
              {{ recipient.first_name }} {{ recipient.last_name }} <br />
              {{ recipient.phone | phone }} <br />
              {{ recipient.email }}
            </div>
            <div class="column">
              {{ recipient.line1 }} {{ recipient.line2 }} {{ recipient.line3 }} <br />
              {{ recipient.city }} {{ recipient.state }} {{ recipient.zip }} {{ recipient.country }} <br />
              <strong>{{ recipient.residential ? 'Residential' : 'Commercial' }}</strong>
            </div>
          </div>
          <div v-if="isSuperUser">
            <a @click="editingRecipient = recipient.id" v-if="editingRecipient !== recipient.id"
               class="button is-small">Edit Recipient</a>
            <span v-if="editingRecipient !== recipient.id">&nbsp;&nbsp;</span>
            <a @click="deleteRecipient(recipient)" v-if="editingRecipient !== recipient.id"
               class="button is-small">Delete Recipient</a>
            &nbsp;&nbsp;
            <a @click="setPrimaryRecipient(recipient)" v-if="user.primary_recipient_id !== recipient.id"
               class="button is-small">Set Primary Recipient</a>
          </div>
          <br />
          <br />
        </div>

        <span v-if="isSuperUser">
                    <button v-if="editingRecipient !== true"
                            type="button"
                            class="button is-small is-primary"
                            @click="editingRecipient = true">Add Recipient
                    </button>
                    <button v-if="editingRecipient === true"
                            type="button"
                            class="button is-small"
                            @click="editingRecipient = false">
                        Cancel Adding
                    </button>
                </span>

        <div v-if="editingRecipient === true">
          <br />
          <br />
          <user-recipient-form v-if="editingRecipient === true"
                               :create="true"
                               :user-id="user.id"
                               @saved="editingRecipient = false"></user-recipient-form>
        </div>
      </div>
      <div class="column">
        <h2 class="subtitle">Orders</h2>
        <table class="table" v-if="userOrders.length > 0">
          <thead>
          <tr>
            <th>Order #</th>
            <th>Total</th>
            <th>Submitted</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="order in userOrders">
            <td>
              <router-link :to="{name: 'order', params:{id:order.id}}">
                {{ order.id }}

              </router-link>
            </td>
            <td>{{ (order.discounted_total !== null ? order.discounted_total : order.total) | currency }}
            </td>
            <td>{{ order.created_at | moment("from", "now") }}</td>
          </tr>
          </tbody>
        </table>
        <div v-if="userOrders.length === 0" class="has-text-centered">
          User has placed no orders.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters}            from "vuex"
import * as types from "../../store/mutation-types"

export default {
  data() {
    return {
      editingUser: false,
      editingRecipient: false, // false or recipient ID
    }
  },
  mounted() {
    if (typeof this.user === 'undefined') {
      this.$store.dispatch(types.LOAD_USER, this.userId).then(data => {
        this.$forceUpdate();
      })
    }
  },
  computed: {
    userId() {
      return parseInt(this.$route.params.id)
    },
    user() {
      return this.$store.state.users.all.find(function (user) {
        return user.id === this.userId
      }.bind(this))
    },
    recipients() {
      return this.userRecipients.filter(recipient => recipient.user_id === parseInt(this.$route.params.id))
    },
    userOrders() {
      return this.$store.state.orders.all.filter(order => order.user_id === parseInt(this.$route.params.id))
                 .sort((a, b) => {
                   return b.id - a.id;
                 })
    },
    ...mapGetters(['isSuperUser', 'users', 'userRecipients', 'orders'])
  },
  methods: {
    deleteRecipient(recipient) {
      let confirm = window.confirm('Are you sure?')
      if (confirm) {
        this.$store.dispatch(types.DELETE_USER_RECIPIENT, recipient).then(data => {
          this.$forceUpdate();
        })
      }
    },
    setPrimaryRecipient(recipient) {
      this.$store.dispatch('SET_PRIMARY_RECIPIENT', {
        user_id: this.user.id,
        user_recipient_id: recipient.id,
      }).then(data => {
        this.$forceUpdate();
      })
    }
  }
};
</script>



// WEBPACK FOOTER //
// User.vue?3df319a2